import { Container } from '@components/Container'
import { HighlightBannerPosterForm } from '@features/home/components/HighlightBannerPosterForm'
import { EditHighlightBannerPosterPageProps } from './interface'

export function EditHighlightBannerPosterPage({
  initialValues,
  onSubmit,
}: EditHighlightBannerPosterPageProps) {
  return (
    <Container>
      <section className='flex items-center justify-between mb-5'>
        <Container.Title showBackBtn>Edit Banner</Container.Title>
      </section>

      <HighlightBannerPosterForm
        initialValues={initialValues}
        onSubmit={onSubmit}
      />
    </Container>
  )
}
